<template>
  <div class="popup popup-stateroom" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  id="stateroomDetail">
    <div class="stateroomDetail-t js-returnDetailBtn">
      <a class="stateroomDetail-returnButton" @click="goBack()">
        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
      </a>
      <p class="stateroomDetail-t-title">舱房详情</p>
    </div>
    <div v-if="stateroomDetail" class="stateroomDetail" id="stateroomDetailInner">
      <template v-if="stateroomDetail.stateroomImageDataList && stateroomDetail.stateroomImageDataList.length>0">
      <template  v-if="stateroomDetail.stateroomImageDataList.length == 1">
        <div class="swiper-container cabinDetailSwiper swiper-container-horizontal swiper-container-ios">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="stateroomDetail-pic">
                <DestinationVideo v-if="stateroomDetail.stateroomImageDataList[0].videoUrl && stateroomDetail.stateroomImageDataList[0].bannerType===2" 
                          :videoUrl="stateroomDetail.stateroomImageDataList[0].videoUrl"
                          :coverUrl="stateroomDetail.stateroomImageDataList[0].imageUrl"
                          :fullScreenPlay="fullScreenPlay"
                          :isChange="isBannerChange"
                          />
                <img v-else :src="stateroomDetail.stateroomImageDataList[0].imageUrl" alt="" class="item-banner" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- <div v-swiper:bannerSwiper="swiperOptions"
             class="swiper-container cabinDetailSwiper swiper-container-horizontal swiper-container-ios">
          <div class="swiper-wrapper">
            <div v-for="(banner, i ) in stateroomDetail.stateroomImageDataList" :key='i' class="swiper-slide">
              <div class="stateroomDetail-pic">
                <DestinationVideo v-if="banner.videoUrl && banner.bannerType===2" 
                          :videoUrl="banner.videoUrl"
                          :coverUrl="banner.imageUrl"
                          />
                <img v-else :src="banner.imageUrl">
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>

          
        </div> -->
        <div class="swiper-container cabinDetailSwiper swiper-container-horizontal swiper-container-ios">
          <swiper id="detailBannerSwiper" :options="swiperOptions" class="swiper-wrapper" ref="bannerSwiper" @slideChange="onBannerChange()">
           
          <swiper-slide style="z-index: 10;" v-for="(banner, index) in stateroomDetail.stateroomImageDataList" :key="index">
            <div class="swiper-slide">
              <div class="stateroomDetail-pic">
                <DestinationVideo v-if="banner.videoUrl && banner.bannerType===2" 
                          :videoUrl="banner.videoUrl"
                          :coverUrl="banner.imageUrl"
                          :fullScreenPlay="fullScreenPlay"
                          :shorexBannerIndex="index+'_a'"
                          :videoId="11+index"
                          :isChange="isBannerChange"
                          />
                <img v-else :src="banner.imageUrl" alt="" class="item-banner" />
              </div>
            </div>
          </swiper-slide>
           <div class="banner-pagination" slot="pagination"></div>
        </swiper>
          <!-- <div class="banner-pagination"></div> -->
          <div class="swiper-button-prev" @click="stateroomImageChange('prev')"></div>
          <div class="swiper-button-next" @click="stateroomImageChange('next')"></div>
        </div>

      </template>
       </template>
      <div class="stateroomDetail-info"
           :class="{ 'background_QH' : stateroomDetail.isQiaohu, 'background_STARRYSKY' : stateroomDetail.isStarrySky, 'background_CUSTOM':
           stateroomDetail.isCustomTheme, 'background_PCPGIFT': stateroomDetail.isPcpGiftTheme}"
           :style="stateroomDetail.isCustomTheme || stateroomDetail.isPcpGiftTheme ? { 'background-image': `url(${stateroomDetail.personalizedStateroomInfo?.roomListImgUrlMB})` } :
            {}">
        <img v-if="stateroomDetail.stateroomType === 'DELUXE' && stateroomDetail.suiteType >= 0"
             class="suite-img"
             :src="GlobalData.suiteImgValue[stateroomDetail.suiteType]"/>
        <div class="stateroomDetail-info-type">
          {{getStateroomName}}
          <img v-if="stateroomDetail.stateroomType === 'DELUXE' && stateroomDetail.suiteType >= 0"
               class="suite-tag"
               @click="showSuitePopup"
               :src="GlobalData.suiteTagImgValue[stateroomDetail.suiteType]"/>
        </div>
        <p class="stateroomDetail-info-area">
          <!-- <span>{{stateroomDetail.stateroomCapacity}}</span> -->
        <span>{{stateroomDetail.stateroomArea}}</span
        ><span>{{stateroomBalconyArea}}</span
        ><span>{{stateroomDetail.stateroomFloor}}</span></p>
<!--        <template v-if="stateroomDetail.stateroomType !== 'DELUXE' && stateroomDetail.suiteType < 0">-->
<!--          <DeviceFeatureTags :tags="stateroomDetail.deviceFeatureTags" :is-detail-txt="false" style="margin-top: 8px"></DeviceFeatureTags>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          <DeviceFeatureTags :tags="stateroomDetail.deviceFeatureTags" :is-detail-txt="false" style="margin-top: 8px"></DeviceFeatureTags>-->
<!--        </template>-->

        <!--                <div class="stateroomDetail-suiteType" style="display: none;"></div>-->
        <div class="stateroomDetail-info-price" v-if="stateroomDetail.stateroomPrice>0">
          <span class="isNrpPrice">{{stateroomDetail.stateroomPriceType}}(含税)：</span><span
          class="stateroomDetail-info-unit">¥</span><span
          class="stateroomDetail-info-priceNum">{{stateroomDetail.stateroomPrice.toFixed(0)}}</span><span class="stateroomDetail-info-qty">/人起</span>
          

          <div class="main-room-detail-price-vr"  v-if="stateroomDetail.vrUrl">
          <div  class="vrMiniSite" @click="showBlacn(stateroomDetail.vrUrl)">
                <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrIcon.png" mode=""/> 进入VR
              </div>
        </div>
        </div>

        <!-- 套房 标签 start -->
      <div v-if="stateroomDetail.roomSummaryList && stateroomDetail.roomSummaryList.length>0 && stateroomDetail.suiteType > 0" class="tab-room-box"
        :class="[stateroomDetail.suiteType == 1 ? 'tab-room-box-see':stateroomDetail.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
        @click="showSuitePopup"
      >
        <div class="tab-room-box-left">
          <div class="tab-room-box-left-item" v-for="item in getTagsArr" :key="item">{{item}}</div>
        </div>
        <div class="tab-room-box-right">
          {{stateroomDetail.suiteRightsCount}}项 <img :src="currImgUrl+'see.png'" class="tab-room-box-right-img" mode="" v-if="stateroomDetail.suiteType == 1"/>
          <img :src="currImgUrl+'sky.png'" class="tab-room-box-right-img" mode="" v-if="stateroomDetail.suiteType == 2"/>
          <img :src="currImgUrl+'star.png'" class="tab-room-box-right-img" mode="" v-if="stateroomDetail.suiteType == 3"/>
        </div>
      </div>
      <!-- 套房 标签 end -->

        
        
      </div>

      

      <div v-if="stateroomDetail.isQiaohu" class="stateroomDetail-describ is-qiaoHu" style="">
        <div class="stateroomDetail-describ-qh-content">
          <p class="stateroomDetail-describ-txt" style="margin-top: 0px">
            主题房内到处可以找到巧虎的可爱身影，床罩、沙发靠垫、壁画，阳台门以及墙上都有巧虎元素的装饰。</p>
          <p class="stateroomDetail-describ-title">预订巧虎主题房可享福利：</p>
          <p class="stateroomDetail-describ-txt">1. 巧虎神秘萌礼<br>2. 和巧虎一起早餐（全程一次）</p>
          <p class="stateroomDetail-describ-title">航程中可以与巧虎一起参加哪些活动？</p>
          <p class="stateroomDetail-describ-txt">1. 巧虎欢迎仪式<br>2. 与巧虎小船长互动拍照留念<br>3. 在海上历奇中心和巧虎一起玩耍</p>
          <!--          <p class="stateroomDetail-describ-title">巧虎主题房预订须知：</p>-->
          <!--          <p class="stateroomDetail-describ-txt">-->
          <!--            巧虎主题房不可与同期其他促销活动及优惠券同享，包括但不限于品牌特惠及限时闪惠活动、招商银行折扣券、抽奖券等优惠促销活动，不可与皇家指定渠道专属优惠同享。-->
          <!--          </p>-->
        </div>
      </div>

      <div v-show="stateroomDetail.isStarrySky" class="stateroomDetail-describ is-starrySky">
        <div class="stateroomDetail-describ-qh-content">
          <p class="stateroomDetail-describ-title" style="margin-top: 0">全新星空主题房介绍：</p>
          <p class="stateroomDetail-describ-txt">全新星空主题房，体验星辰大海的梦幻之旅。独特的太空主题装饰和星空投影灯，让您和家人仿佛置身于浩瀚星空下，感受宇宙的浩瀚与神秘。</p>
          <p class="stateroomDetail-describ-title">星空房内饰含：</p>
          <p class="stateroomDetail-describ-txt">沙发抱枕（含枕芯）、星空床罩 (折叠在柜子里)、星空投影灯、创意月球灯、星空桌垫、太空人摆件、墙面磁铁、温馨提示卡、星空投影灯使用说明</p>
          <p class="stateroomDetail-describ-title">房间须知：</p>
          <p class="stateroomDetail-describ-txt">
            1. 入住星空房的客人，将会被预收取每舱房100美金作为星空房主题装饰和装置的押金，于登轮时计入船上消费账单。在您离开光谱号时，请不要带走房间内的装饰和装置。若未发生舱房主题装饰损坏或者遗失等情况，上述押金将原路退回。<br>
            2. 房间内设置星空投影灯，客人可自行调节投影图片。<br>
            3. 房间图片为效果图，仅供参考，以实际入住为准。<br>
            4. 床罩可替换为星空床罩，如需要请联系客房服务生布置。
          </p>
        </div>
      </div>

      <div class="stateroomDetail-describ">
        <div>
          <p class="stateroomDetail-describ-title">舱房描述</p>
          <p class="stateroomDetail-describ-txt" v-html="stateroomDetail.stateroomDescription">

          </p>
          <p class="stateroomDetail-describ-promp">注：舱房信息仅供参考，实际设施请以舱房内</p>
          <p class="stateroomDetail-describ-promp">*房间图片仅供参考，以实际入住为准</p>
          <p class="stateroomDetail-describ-promp">*房间价格以实时为准</p>
        </div>
      </div>
      <div 
           class="stateroomDetail-describ">
        <div>
          <p class="stateroomDetail-describ-title">舱房详情</p>
          <div v-if="isFacilities" class="stateroomDetail-facilities">
            <span class="is-characteristic"></span>该设施为本房型特色设施
          </div>

          <div class="device-group-tags-box">
            <div class="facilities-category">入住人数</div>
            <ul class="facilities-list">
              <li style="width: 80%;">
                <img style="height: 14px;width: 14px;" :src="currImgUrl+'peopleCount.png'" />
                <div>可入住 {{stateroomDetail.guestNumber ? stateroomDetail.guestNumber:stateroomDetail.currentGuestNumber}} 人（6月龄以上需计入人数）</div>
                <div class="common-clr"></div>
              </li>
            </ul>
            <div class="common-clr"></div>
          </div>

          <template v-if="stateroomDetail.deviceGroupTags && stateroomDetail.deviceGroupTags.length && cruiseDetail.isRow == false">

          <device-group-tags v-for="(item,index) in stateroomDetail.deviceGroupTags" :key="index"
                             :category="item.name"
                             :facilities="item.deviceTags"
                             :index="index"
                             :length="stateroomDetail.deviceGroupTags && stateroomDetail.deviceGroupTags.length ? stateroomDetail.deviceGroupTags.length : 0"
                             ></device-group-tags>
                             </template>
        </div>
      </div>
      <div class="warmPrompt stateroomDetail-describ">
        <div class="cabinDetail-wrapper">
          <div class="lineTitle">
            <div class="lineTitle-line"></div>
             {{ stateroomDetail.stateroomNrpTitle}}
          </div>
          <div class="unsubscribeCon-bubbleInfo" v-html="nrpDescription">

          </div>
        </div>
      </div>
      
      <!--            <div class="stateroomDetail-suiteImage" v-show="stateroomDetail.suiteMobileImageUrl && stateroomDetail.suiteMobileImageUrl.length > 0">-->
      <!--                <img :src="stateroomDetail.suiteMobileImageUrl">-->
      <!--            </div>-->
    </div>
    <StateroomSuitePopup v-if="stateroomDetail"
                         :suiteImage="stateroomDetail.suiteMobileImageUrl"
                         :isShow="isShowSuitePopup"
                         :onGoBack="closeSuitePopup"
    />
  </div>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
const DestinationVideo = () => import('@/components/alert/DestinationVideoFromPcp')
const DeviceGroupTags = () => import('@/components/Cruise/DeviceGroupTags')

const StateroomSuitePopup = () => import('@/components/Cruise/StateroomSuitePopup')
// const DeviceFeatureTags = ()=> import("@/components/Cruise/DeviceFeatureTags");
export default {
  name: "StateroomDetail",
  components: {
    DeviceGroupTags,
    StateroomSuitePopup,
    // DeviceFeatureTags,
    DestinationVideo,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    onGoBack: {
      type: Function
    },
    
    isShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean
    },
    stateroomDetail: {
      type: Object,
      default () {
        return {
          stateroomImages: [],
          stateroomName: '',
          stateroomCategory: '',
          stateroomPriceType: '',
          stateroomPrice: 0,
          stateroomCapacity: '',
          stateroomArea: '',
          stateroomBalcony: '',
          stateroomFloor: '',
          isQiaohu: false,
          isStarrySky: false,
          isPcpGiftTheme: false,
          isCustomTheme: false,
          stateroomDescription: '',
          stateroomNrpTitle: '',
          stateroomNrpText: '',
          suiteMobileImageUrl: '',
          stateroomShelter: '',
          deviceFeatureTags: [],
          deviceGroupTags: [],
          swiper: null
        }
      }
    },
    shipCode: {
      type: String,
      default: ""
    },
    showRow: {
            type: Boolean,
            default () {
                return false
            }
        },
  },
  data () {
    return {
      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
      imgUrl: process.env.VUE_APP_IMG_URL,
      isShowSuitePopup: false,
      swiperOptions: {
        // loop: true,
        pagination: {
          type: 'bullets',
          el: '.banner-pagination', // 分页器所在的DOM节点，可以是CSS选择器或者DOM对象
          clickable: true // 允许点击分页器上的按钮跳转到对应的幻灯片
        }
      },
      isBannerChange: null,
      fullScreenPlay: false,
      nrpDescription:''
    }
  },
  watch: {
    isShow(val) {
      if(!val) document.getElementById('stateroomDetailInner').scrollTop = 0;
    },
    stateroomDetail:{
      handler(val) { 
        if(val){
          if(val.stateroomNrpTitle == '收费退订'){
        // 收费退订
                if(this.showRow){
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
      }else{
        // 常规退订
                if(this.showRow){
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                }else{
                    this.nrpDescription = this.$store.state.cruiseRow.nrpData.cancelPolicy
                }
      }
        }
      },
      deep: true,
      immediate: true
    }
    
  },
  methods: {
    // 进入VR
    showBlacn(str){
      window.open(`https://mobile.rcclchina.com.cn/${str}`,'_blank')
    },
    goBack () {
      this.pauseAllVideo();
      this.onGoBack()
    },
    showSuitePopup() {
      if(this.shipCode === 'OV') return;
      this.isShowSuitePopup = true;
    },
    closeSuitePopup() {
      this.isShowSuitePopup = false;
    },
    stateroomImageChange(slide) {
      console.log('点击了 stateroomImageChange')
      this.swiper = this.$refs.bannerSwiper.$swiper
      
        console.log(this.swiper,'this.swiper')
      if (slide == 'prev') {
        this.swiper.slidePrev()
      } else {
        this.swiper.slideNext()
      }
     
    },
    onShowStateroomSuitePopup(suiteImage) {
      if (suiteImage) {
        this.showStateroomSuitePopup(suiteImage);
      }
    },
    onBannerChange() {
      if(this.fullScreenPlay) return;
      this.isBannerChange = new Date().getTime().toString();
      this.pauseAllVideo();
    },
    pauseAllVideo() {
      // 获取所有stateroomDetail-pic元素
      const picElements = document.querySelectorAll('.stateroomDetail-pic')

      // 遍历每个pic元素，查找video标签并暂停播放
      picElements.forEach(picElement => {
        const videoElements = picElement.querySelectorAll('video')
        videoElements.forEach(video => {
          if (!video.paused) {
            video.currentTime = 0
            video.pause()
          }
        })
      })
    }
  },
 
  computed: {
    isFacilities() {
      let isFeature = false;
      if(this.stateroomDetail && this.stateroomDetail.deviceGroupTags && this.stateroomDetail.deviceGroupTags.length){
        for(let i = 0; i < this.stateroomDetail.deviceGroupTags.length; i++) {
          let deviceGroupTags = this.stateroomDetail.deviceGroupTags[i];
          for(let j = 0; j < deviceGroupTags.deviceTags.length; j++) {
            let deviceTags = deviceGroupTags.deviceTags[j];
            if(deviceTags.isFeature) {
              isFeature = true;
              break;
            }
          }
          if(isFeature) break;
        }
      }
      return isFeature;
    },
    // 获取tag 列表
    
    getTagsArr(){
      if(this.stateroomDetail.roomSummaryList  && this.stateroomDetail.roomSummaryList.length > 0){
        // if(this.stateroomDetail.roomSummaryList.length == 4){
        //   return this.stateroomDetail.roomSummaryList
        // }else{
        //   return this.stateroomDetail.roomSummaryList.slice(0,4)
        // }
        return this.stateroomDetail.roomSummaryList
      }else{
        return []
      }
    },
    stateroomBalconyArea () {
      const stateroom = this.stateroomDetail
      if (!stateroom.stateroomBalcony || stateroom.stateroomBalcony == '' || stateroom.stateroomBalcony == '无') {
        return '无阳台'
      }
      if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
        return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.stateroomBalcony
      }
      return stateroom.stateroomBalcony
    },
    getStateroomName() {
      const stateroom = this.stateroomDetail
      let name = stateroom.stateroomName + ''
      const shelter = stateroom.stateroomShelter
      if (shelter && shelter.length > 0 && name && name.indexOf('遮挡') < 0) {
        name += "（有遮挡）"
      }
      let code = stateroom.stateroomCategory
      if (code && code.indexOf('_') >= 0) {
        code = code.split('_')[0]
      }
      return `${name}_${code}`
    },
    fortyEightHoursNrpCruiseDetail() {
      return nrpConfig.fortyEightHoursNrp.description
    },
    // 航线详情
    cruiseDetail() {
      return this.$store.state.cruise.cruiseDetail.data;
    },
  }
}
</script>

<style lang="less" scoped>
#stateroomDetail.popup {
  position: fixed;
  background-color: #F6F7F8;
  transform: translate3d(100%, 0, 0);
  display: block;
}
#stateroomDetail.modal-in {
  position: fixed;
  background-color: #F6F7F8;
  transform: translate3d(0, 0, 0);
}
#stateroomDetail.modal-out {
  transform: translate3d(100%, 0, 0);
}
.stateroomDetail-t {
  position: absolute;
  width: 100%;
  text-align: center;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  z-index: 10;
  .stateroomDetail-returnButton {
    width: 30px;
    position: absolute;
    top: 4px;
    left: 20px;
    text-align: left;
    img {
      width: 33%;
    }
  }
  .stateroomDetail-t-title {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    margin: 0;
  }
}

.stateroomDetail {
  height: calc(100% - 50px);
  overflow: scroll;
  margin-top: 50px;
  padding-bottom: 50px;
  .swiper-container {
    padding: 0px;
  }
  .swiper-button-prev {
    background-image: url(https://resource.rcclchina.com.cn/cruiseDetail/leftImg.png);
    transform: translate3d(0px, 0px, 0px) scale(0.5);
    color: white;
  }
  .swiper-button-next {
    background-image: url(https://resource.rcclchina.com.cn/cruiseDetail/rightImg.png);
    transform: translate3d(0px, 0px, 0px) scale(0.5);
    color: white;
  }
  .stateroomDetail-pic {
    position: relative;
    width: 100%;
    height: 211px;
    img {
      width: 100%;
    }
    & .item-banner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .stateroomDetail-info {
    position: relative;
    padding: 13px 20px 15px;
    background-color: #fff;
    .stateroomDetail-info-type {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #333333;
      letter-spacing: 1.87px;
      font-weight: bold;
      line-height: 1.2;
      width: 73%;
      position: relative;
      & .info-title {
        float: left;
        display: inline-block;
        max-width: 80%;
      }
    }
    & .suite-img {
      position: absolute;
      top: 13px;
      right: 20px;
      height: 30px;
    }
    & .suite-tag {
      width: 50px;
      margin-bottom: -2px;
    }
    .stateroomDetail-suiteType {
      display: none;
      background: url(https://resource.rcclchina.com.cn/tui2/hp_stateroomTag.png) center no-repeat;
      background-size: 100% 100%;
      font-size: 11px;
      color: #333333;
      padding: 0px 10px;
      width: 69px;
    }
    .stateroomDetail-info-price {
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      margin-top: 8px;
      position: relative;
      span.stateroomDetail-info-unit {
        font-size: 12px;
        margin: 0 2px;
        color: #FF5055;
      }
      .stateroomDetail-info-priceNum {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #FF5055;
        line-height: 15px;
      }
    }
    .stateroomDetail-info-area {
      font-size: 12px;
      line-height: 1;
      color: #666666;
      letter-spacing: 0;
      margin-top: 8px;
      width: 78%;
      span {
        display: inline-block;
      }
      span + span {
        margin-left: 6px;
        padding-left: 6px;
        border-left: 1px solid #979797;
      }
    }

    p {
      margin: 0;
    }

    .detail_desc_tags {
      font-size: 12px;
      margin-top: 8px;
      overflow: hidden;
      & .tags_list {
        float: left;
        & > li {
          display: inline-block;
          overflow: hidden;
          margin-right: 8px;
          height: 16px;
          & > img {
            float: left;
            height: 16px;
          }
          & > div {
            float: left;
            line-height: 15px;
            letter-spacing: -1px;
          }
        }
      }
    }
  }
  .background_QH {
    background-image: url(https://resource.rcclchina.com.cn/QIAOHU/Mobile_detail.jpg);
    background-size: 100% 100%;
    margin-top: 10px;
    padding: 4px 20px;
    min-height: 70px;
  }
  .background_STARRYSKY {
    background-image: url(https://resource.rcclchina.com.cn/STARRYSKY/MB_detail_bg.jpg);
    background-size: 100% 100%;
    margin-top: 10px;
    padding: 4px 20px;
    min-height: 70px;
  }
  .background_CUSTOM {
    background-size: 100% 100%;
    margin-top: 10px;
    padding: 4px 20px;
    min-height: 70px;
  }
  .background_PCPGIFT {
    background-size: 100% 100%;
    background-color: #fff;
    margin-top: 10px;
    padding: 4px 20px;
    min-height: 70px;
  }

  .stateroomDetail-describ {
    position: relative;
    padding-top: 10px;
    background-color: #F6F7F8;
    > div {
      padding: 16px 20px 12px;
      background-color: #fff;
    }
    p {
      margin: 0;
    }
    p.stateroomDetail-describ-txt {
      margin-top: 10px;
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      line-height: 20px;
      & .starry_sky_list {
        list-style: disc;
        padding-left: 15px;
        & li {
          list-style: disc;
        }
      }
    }
    .stateroomDetail-describ-title {
      position: relative;
      padding-left: 9px;
      font-size: 14px;
      line-height: 16px;
      color: #4A90E2;
      letter-spacing: 0;
    }
    .stateroomDetail-describ-title:before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      display: block;
      width: 3px;
      height: 12px;
      background: #4A90E2;
      border-radius: 1px;
    }

    .stateroomDetail-describ-promp {
      font-family: PingFang-SC-Medium;
      font-size: 10px;
      color: #666666;
      letter-spacing: 0;
      line-height: 16px;
      margin-bottom: 0px;
      margin-top: 0px;
    }

    .stateroomDetail-facilities {
      position: absolute;
      top: 27px;
      right: 20px;
      font-size: 12px;
      line-height: 12px;
      & .is-characteristic {
        //position: absolute;
        //left: -15px;
        //top: 0.12rem;
        //font-size: 12px;
        //margin-right: 3px;
        //color: #0173BC;
        &::before {
          position: absolute;
          left: -8px;
          top: 4px;
          display: inline-block;
          content:"";
          height: 5px;
          width: 5px;
          border-radius: 5px;
          background-color: #0173BC;
        }
      }
    }
  }

  .is-qiaoHu {
    .stateroomDetail-describ-title {
      margin-top: 11px;
    }
  }
  .is-starrySky {
    .stateroomDetail-describ-title {
      margin-top: 11px;
    }
  }


  .stateroomDetail-suiteImage {
    img {
      width: 100%;
    }
  }
}
/deep/.swiper-container-horizontal .swiper-pagination-bullets .swiper-pagination-bullet{
  margin: 0 2px;
}
/deep/.swiper-pagination-bullet {
  background: rgba(238,238,238,.8);
}
/deep/.swiper-pagination-bullet-active {
  background: #EEEEEE;
}
</style>

<style lang="less">
#stateroomDetail .cabinDetail-box {
  padding: 18px 20px 12px;
  background-color: #fff;
  .lineTitle {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 0 10px;
    font-size: 12px;
    line-height: 16px;
    color: #4A90E2;
    .lineTitle-line {
      width: 3px;
      height: 12px;
      margin-right: 6px;
      background-color: #4A90E2;
    }
  }
  .cabinDetail-txt {
    padding-bottom: 13px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    p {
      margin: 0;
    }
    .cabinDetail-txt-bold {
      color: #333;
      font-weight: bold;
    }
  }
}

.main-room-detail-price-vr .vrMiniSite{
  width: 79.5px;
  height: 30px;
  position: absolute;
  top: -6px;
  right: -20px;
  background-color: rgba(254, 200, 65, 0.69);
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
}
.main-room-detail-price-vr .vrMiniSite img{
  width: 21px;
  height: 15px;
}

.tab-room-box{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  align-items: flex-start;
  // margin-bottom: 8px;
}
.tab-room-box-see{
  color: #43797D;
  border-color: #43797D;
}
.tab-room-box-sky{
  color: #3D60AF;
  border-color: #3D60AF;
}
.tab-room-box-star{
  color: #8B3C63;
  border-color: #8B3C63;
}
.tab-room-box-left{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.tab-room-box-left-item{
  font-weight: 400;
  font-size: 10px;
  padding: 1px 4px;
  border: 1px solid ;
  border-radius: 2px;
  margin-right: 4px;
  margin-bottom: 4px;
}
.tab-room-box-right{
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  flex-shrink: 0;
}
.tab-room-box-right-img{
  width: 10px;
  height: 10px;
  margin-left: 3px;
}

.device-group-tags-box{
  border-bottom: 1px solid #EEEEEE;
  box-sizing: border-box;
}
.facilities-category {
  font-size: 14px;
  margin: 10px 0 10px;
  color: #333333;
}
.facilities-list {
  font-size: 12px;
  color: #747d80;
  display: flex;
  flex-wrap: wrap;
  & > li {
    flex-direction: column;
    width: 33.33%;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding-right: 10px;
    position: relative;
    min-height: 14px;
    & > img {
      float: left;
      height: 11px;
      width: 11px;
      margin-right: 4px;
    }
    & > div {
      overflow: hidden;
      margin-top: -1px;
      line-height: 14px;
      word-wrap: break-word;
      word-break: normal;
    }
    & .is-characteristic {
      //font-size: 12px;
      //margin-left: 4px;
      //color: #0173BC;
      display: inline-block;
      height: 5px;
      width: 5px;
      border-radius: 5px;
      margin-left: 3px;
      margin-bottom: 2px;
      background-color: #0173BC;
    }
  }
}

.banner-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  font-size: 0;
  line-height: 6px;
  &.swiper-pagination-bullets {
    bottom: 32px;
    height: 6px;
    & .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #FFFFFF;
      opacity: .6;
    }
    .swiper-pagination-bullet-active {
      border-radius: 6px;
      width: 16px;
    }
  }
  &.is-suite {
    &.swiper-pagination-bullets {
      bottom: 42px;
      & .swiper-pagination-bullet {
        width: 30px;
        height: 1px;
        border-radius: 1px;
        background: #0172B8;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        background: #ffffff;
        opacity: 1;
      }
    }
  }
}

.cabinDetail-wrapper{
  padding: 18px 20px 12px;
  background-color: #fff;
}
.cabinDetail-wrapper .lineTitle{
  display: flex;
    align-items: center;
    padding: 0 0 6px;
    font-size: 12px;
    line-height: 16px;
    color: #4A90E2;
}
.cabinDetail-wrapper .lineTitle .lineTitle-line{
    width: 3px;
    height: 12px;
    margin-right: 6px;
    background-color: #4A90E2;
}

.unsubscribeCon-bubbleInfo p {
    font-size: 12px;
    color: #5e5e5e;
    margin-bottom: 0;
    margin-top: 4px;
}
.cabinDetail-txt .cabinDetail-txt-bold {
    margin: 10px 0 0;
}
.unsubscribeCon-bubbleInfo p span {
    font-size: 13px;
    color: #4A90E2;
    font-weight: 600;
}
.bubbleInfoCon-title{
    font-size: 14px;
    font-weight: 600 !important;
    color: #4A90E2 !important;
}

#stateroomDetail .cabinDetail-box {
    padding: 0;
}

</style>
